export default __webpack_public_path__ + "static/jost-all-300-normal-4c395f293b2f5584621fd76e5d74bafd.woff";